export const menus = [
  {
    name: 'Histórico de Envios',
    icon: 'dashboard',
    link: '/principal/individual',
    open: false,
    modal: false,
    ativo: true
  },
  {
    name: 'Módulos',
    icon: 'widgets',
    link: false,
    open: false,
    modal: false,
    ativo: false,
    sub: [
      {
        name: 'Qualificação Cadastral',
        link: '/qualificacao-cadastral',
        icon: 'supervised_user_circle',
        chip: false,
        open: false,
        modal: false,
        ativo: false
      },
      {
        name: 'Empregador',
        link: false,
        icon: 'location_city',
        chip: false,
        open: false,
        modal: false,
        ativo: false,
        sub: [
          {
            name: 'S-1000 - Inf. Empregador',
            link: '/s1000',
            modal: false,
            ativo: false
          },
          {
            name: 'S-1005 - Unid. Órgãos Públicos',
            link: '/s1005',
            modal: false,
            ativo: false
          },
          {
            name: 'S-1010 - Tab. Rubricas',
            link: '/s1010',
            modal: false,
            ativo: false
          },
          {
            name: 'S-1020 - Tab. Lotações Tributárias',
            link: '/s1020',
            modal: false,
            ativo: false
          }
        ]
      },
      {
        name: 'Eventos Não Periódicos',
        link: false,
        icon: 'location_city',
        chip: false,
        open: false,
        modal: false,
        ativo: false,
        sub: [
          {
            name: 'Servidores Efetivos/Comissionados',
            link: false,
            modal: false,
            open: false,
            chip: false,
            ativo: false,
            sub: [
              {
                name: 'S-2200 - Cad. Inicial do Vínculo e Admissão',
                link: '/s2200',
                modal: false,
                ativo: false
              },
              {
                name: 'S-2205 - Alteração de Dados Cadastrais do Trabalhador',
                link: '/s2205',
                modal: false,
                ativo: false
              },
              {
                name: 'S-2206 - Alteração de Contrato de Trabalho/Relação Estatutária',
                link: '/s2206',
                modal: false,
                ativo: false
              },
              {
                name: 'S-2230 - Afastamento Temporário',
                link: '/s2230',
                modal: false,
                ativo: false
              },
              {
                name: 'S-2231 - Cessão/Exercício em Outro Órgão',
                link: '/s2231',
                modal: false,
                ativo: false
              },
              {
                name: 'S-2299 - Desligamento',
                link: '/s2299',
                modal: false,
                ativo: false
              }
            ]
          },
          {
            name: 'Servidores Temporários',
            link: false,
            modal: false,
            open: false,
            chip: false,
            ativo: false,
            sub: [
              {
                name: 'S-2300 - Trabalhador Sem Vínculo de Emprego/Estatutário - Início',
                link: '/s2300',
                modal: false,
                ativo: false
              },
              {
                name: 'S-2306 - Trabalhador Sem Vínculo de Emprego/Estatutário - Alteração Contratual',
                link: '/s2306',
                modal: false,
                ativo: false
              },
              {
                name: 'S-2399 - Término - Trabalhador Sem Vínculo de Emprego/Estatutário.',
                link: '/s2399',
                modal: false,
                ativo: false
              },
            ]
          },
          {
            name: 'Inativos e Pensionistas',
            link: false,
            modal: false,
            open: false,
            chip: false,
            ativo: false,
            sub: [
              {
                name: 'S-2400 - Cadastro de Beneficiário',
                link: '/s2400',
                modal: false,
                ativo: false
              },
              {
                name: 'S-2405 - Cadastro de Beneficiário - Entes Públicos - Alteração',
                link: '/s2405',
                modal: false,
                ativo: false
              },
              {
                name: 'S-2410 - Cadastro de Benefício',
                link: '/s2410',
                modal: false,
                ativo: false
              },
              {
                name: 'S-2416 - Cadastro de Benefício - Entes Públicos - Alteração',
                link: '/s2416',
                modal: false,
                ativo: false
              },
              {
                name: 'S-2420 - Cadastro de Benefício - Entes Públicos - Término',
                link: '/s2420',
                modal: false
              }
            ]
          }
        ]
      },
      {
        name: 'Eventos Periódicos',
        link: false,
        icon: 'location_city',
        chip: false,
        open: false,
        modal: false,
        ativo: false,
        sub: [
          {
            name: 'Servidores Efetivos/Comissionados',
            link: false,
            modal: false,
            open: false,
            chip: false,
            ativo: false,
            sub: [
              {
                name: 'S-1200 - Remun. Trabalhador RGPS',
                link: '/s1200',
                modal: false,
                ativo: false
              },
              {
                name: 'S-1202 - Remuneração de Servidor RPPS',
                link: '/s1202',
                modal: false,
                ativo: false
              },
              {
                name: 'S-1210 - Comissionados RGPS',
                link: '/s1210-comissionados',
                modal: false,
                ativo: false
              },
              {
                name: 'S-1210 - Efetivos do RPPS',
                link: '/s1210-efetivos-rpps',
                modal: false,
                ativo: false
              }
            ]
          },
          {
            name: 'Inativos e Pensionistas',
            link: false,
            modal: false,
            open: false,
            chip: false,
            ativo: false,
            sub: [
              {
                name: 'S-1207 - Benefícios - Entes Públicos',
                link: '/s1207',
                modal: false,
                ativo: false
              },
              {
                name: 'S-1210 - Pagamento Inativos e Pensionistas',
                link: '/s1210',
                modal: false,
                ativo: false
              }
            ]
          },
          {
            name: 'Fechamento Periódico',
            link: false,
            modal: false,
            open: false,
            chip: false,
            ativo: false,
            sub: [
              {
                name: 'S-1299 - Fechamento da Folha de Pagamento',
                link: '/s1299',
                modal: false,
                ativo: false
              }
            ]
          }
        ]
      },
      {
        name: 'Eventos de SST',
        link: false,
        icon: 'person',
        chip: false,
        open: false,
        modal: false,
        ativo: false,
        sub: [
          {
            name: 'Servidores Efetivos/Comissionados/Temporários',
            link: false,
            modal: false,
            open: false,
            chip: false,
            ativo: false,
            sub: [
              {
                name: 'S-2210 - Comunicação de Acidente de Trabalho',
                link: '/s2210',
                modal: false,
                ativo: false
              },
              {
                name: 'S-2220 - Monitoramento da Saúde do Trabalhador',
                link: '/s2220',
                modal: false,
                ativo: false
              },
              {
                name: 'S-2240 - Condições Ambientais de Trabalho',
                link: '/s2240',
                modal: false,
                ativo: false
              }
            ]
          }
        ]
      }

      /*,
            {
              name: 'Empregados',
              icon: 'supervisor_account',
              chip: false,
              open: false,
              modal: false
            },
            {
              name: 'Trabalhadores sem Vínculo',
              icon: 'assignment_late',
              chip: false,
              open: false,
              modal: false
            },
            {
              name: 'Folha de Pagamento',
              icon: 'extension',
              chip: false,
              open: false,
              modal: false
            }*/
    ]
  },
  {
    name: 'Configurações',
    icon: 'settings_applications',
    link: false,
    open: false,
    modal: false,
    ativo: false,
    sub: [
      {
        name: 'Origem dos Dados',
        link: '/origem-dados',
        icon: 'business',
        chip: false,
        open: false,
        modal: false,
        ativo: false
      } /*,
          {
            name: 'Grupo de Acessos',
            icon: 'group_add',
            chip: false,
            open: false,
            modal: false
          }*/,
      {
        name: 'Vincular Regra de Benefício ao eSocial (Tabela 25)',
        link: '/tabela25',
        icon: 'note',
        chip: false,
        open: false,
        modal: false,
        ativo: false
      },
      {
        name: 'Ambientes de Trabalho',
        link: '/ambientetrabalho',
        icon: 'note',
        chip: false,
        open: false,
        modal: false,
        ativo: false
      },
      {
        name: 'Agentes Nocivos',
        link: '/agentenocivo',
        icon: 'note',
        chip: false,
        open: false,
        modal: false,
        ativo: false
      },
      {
        name: 'Resp. Registro Ambiental',
        link: '/responsavelambiente',
        icon: 'note',
        chip: false,
        open: false,
        modal: false,
        ativo: false
      },
      {
        name: 'Identificador da Tabela',
        link: '/IdentTab',
        icon: 'note',
        chip: false,
        open: false,
        modal: false,
        ativo: false
      },
      {
        name: 'Parâmetros Gerais',
        link: '/parametros-gerais',
        icon: 'settings_applications',
        chip: false,
        open: false,
        modal: false,
        ativo: false
      },
      {
        name: 'Usuários',
        link: '/usuarios',
        icon: 'accessibility',
        chip: false,
        open: false,
        modal: false,
        ativo: false
      }
    ]
  }
];
